import './HeroSection.css';
import portrait from '../assets/images/profil.png';

function HeroSection() {
  return (
    <section className="hero" id="accueil">
      <div className="hero__content section-card">
        <div className="hero__text">
          <h1>
            Analyste programmeur
          </h1>
          <p className="section-copy">
            Développeur passionné, j&apos;aime construire des interfaces claires, rapides et soignées.
            Ce portfolio met en valeur mon profil avec une identité visuelle moderne et une structure
            propre en TypeScript.
          </p>

          <div className="hero__actions">
            <a className="hero__button hero__button--primary" href="#contact">
              Me contacter
            </a>
            <a className="hero__button hero__button--ghost" href="#apropos">
              Découvrir mon profil
            </a>
          </div>

          <div className="hero__stats">
            <article>
              <strong>ERP</strong>
              <span>Maintenance et évolution d&apos;applications métiers</span>
            </article>
            <article>
              <strong>Web</strong>
              <span>React, TypeScript, Angular, Django, PHP</span>
            </article>
            <article>
              <strong>SQL</strong>
              <span>Conception, optimisation et exploitation de données</span>
            </article>
          </div>
        </div>

        <div className="hero__visual" aria-hidden="true">
          <div className="hero__ring hero__ring--one" />
          <div className="hero__ring hero__ring--two" />
          <div className="hero__portrait-card">
            <img src={portrait} alt="Thomas Amand" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
